import { apiGet, apiSend } from './client';
import type { CharacterBossParsesResponse, CharacterDetailResponse } from './types';

export type ParseMetric = 'DAMAGE' | 'HEALING';

function metricQuery(metric?: ParseMetric) {
  return metric && metric !== 'DAMAGE' ? `?metric=${encodeURIComponent(metric)}` : '';
}

export function fetchCharacter(id: string, metric: ParseMetric = 'DAMAGE') {
  return apiGet<CharacterDetailResponse>(`/characters/${encodeURIComponent(id)}${metricQuery(metric)}`);
}

export function fetchCharacterBossParses(characterId: string, bossId: string, metric: ParseMetric = 'DAMAGE') {
  return apiGet<CharacterBossParsesResponse>(`/characters/${encodeURIComponent(characterId)}/bosses/${encodeURIComponent(bossId)}/parses${metricQuery(metric)}`);
}


export function updateCharacterClass(id: string, className: string | null) {
  return apiSend<CharacterDetailResponse>(`/characters/${encodeURIComponent(id)}/class`, 'PATCH', { className });
}
